import {React,useContext} from 'react'
import {useNavigate} from 'react-router-dom'
import {conitem} from '../context/Contextitem'
import {Wishlistdata} from '../context/Wishcontainer'

const Product = ({data}) => {
  const navigate = useNavigate()
  const wishdata = useContext(Wishlistdata)
  const value = useContext(conitem)
  const {addproduct} = value
  const {addwishlist} =  wishdata
  
  return (
    <div id='house'>
    <div className='category-wraper'>
      <div id='product-wrapper'>
      <img className='product-image' src={`/asset/${data.image}`} />
      {/* <div id='product-wishlist-container'>
      <img onClick={()=>addwishlist({id:data.id,price:data.price,title:data.title,image:data.image})}  style={{width:'25px'}} src='/asset/Frame 904.png'/>
      </div> */}
      </div>
      <p className='product-title'>{data.title}</p>
      <div className='price-wrapper'>
        <h4> ${data.price}</h4>
        <h4> stock: {data.stock}</h4>
      </div>
      <div className='product-btn-wrapper'>
      <button onClick={()=>navigate(`/Product/${data.id}`)}>View product</button>
      <button onClick={()=>addproduct({id:data.id,price:data.price,title:data.title,image:data.image})}>Add Basket</button>
      </div>
    </div>
   
    </div>
  )
}

export default Product